export default {
    appTitle: 'Providers web',
    backLabel: 'Back',
    title:'2-Step Verification Enabled',
    body:{
      message:'We have sent a verification email to <strong>{email}</strong> to complete the login safely. <br><br> Enter from the email link to complete the entry',
      buttonResend:'Resend',
      buttonResendTimer:'Retry in {timer} mins.',
      disclaimer:'This process may take a few minutes. In case of not receiving it, check your spam mailbox'
    },
    errors:{
      invalidLink:'This link is not available'
    },
    ResendLinkMessages:{
      success:'Verification message has been sent successfully.',
      error:'The verification message could not be sent.'
    }
  }
